<template lang="html">
  <ul class="project-list">
    <ProjectListItem
      v-for="item in projects"
      :key="item.id"
      :project="item"
    />
  </ul>
</template>

<script>
import ProjectListItem from 'beisheim/components/elements/project-list-item'

export default {
  components: {
    ProjectListItem
  },
  props: {
    projects: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/scale';
  @import 'beisheim/scss/grid';

  .project-list {
    display: flex;
    flex-direction: column;
    margin: scale(1) auto;
    min-width: $min-width;
    max-width: $max-width;
    @include grid-spacing(margin-bottom, 2);
  }
</style>
